import React, { useState } from 'react';
import cooterCapitalLogo1 from '../../public/logo-cooter-capital-1.png';
import VideoModal from './shared/VideoModal';
import './DashboardBottomLogo.css';

const DashboardBottomLogo: React.FC = () => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  const handleLogoClick = () => {
    setIsVideoModalOpen(true);
  };

  const handleCloseVideo = () => {
    setIsVideoModalOpen(false);
  };

  return (
    <>
      {/* Video Modal */}
      <VideoModal
        isOpen={isVideoModalOpen}
        onClose={handleCloseVideo}
        videoSrc="/cooter-capital-where-dreams-are-made.mp4"
        title="Cooter Capital - Where Dreams Are Made"
      />

      <div className="dashboard-bottom-logo">
        <img
          src={cooterCapitalLogo1}
          alt="Cooter Capital Large Logo"
          className="large-bottom-logo clickable-bottom-logo"
          onClick={handleLogoClick}
          title="Click to watch Cooter Capital - Where Dreams Are Made"
        />
      </div>
    </>
  );
};

export default DashboardBottomLogo;
